import styled from '@emotion/styled'
import { mediaMax } from '@/styles/mixins'

export const ImageWrapper = styled.div`
  width: 60vw;
  height: 65vh;
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: bottom;
  margin-top: 6rem;
  margin-bottom: 6rem;
  ${mediaMax.md} {
    margin-top: 0;
    margin-bottom: 6rem;
    width: 100%;
    height: 40vh;
  }
  ${mediaMax.xs} {
    width: 100%;
    height: 40vh;
  }
`
